import { IconProps } from './interfaces';

export const IconHidePassword = ({ className }: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            className={className}
        >
            <path
                d="M18.1019 8.69468C18.3911 8.337 18.9158 8.28155 19.2737 8.57066C19.6316 8.8599 19.6869 9.38458 19.3978 9.74253C18.9431 10.3054 18.3741 10.9195 17.6888 11.516L19.473 14.638C19.7013 15.0376 19.563 15.5474 19.1634 15.7757C18.7638 16.004 18.255 15.8647 18.0267 15.4652L16.3528 12.5355C15.4556 13.1267 14.4141 13.6414 13.2181 13.9837L13.7386 17.1019C13.8142 17.5558 13.5078 17.9851 13.054 18.0609C12.6001 18.1365 12.1708 17.8302 12.095 17.3763L11.5853 14.3216C11.0798 14.3885 10.5519 14.4271 10.0003 14.4271C9.44853 14.4271 8.91996 14.3895 8.41436 14.3226L7.90557 17.3763C7.82987 17.8302 7.40052 18.1365 6.94659 18.0609C6.49261 17.9852 6.18539 17.5559 6.26104 17.1019L6.78057 13.9837C5.5851 13.6414 4.54369 13.1274 3.64678 12.5365L1.97393 15.4652C1.74557 15.8648 1.23582 16.0041 0.836235 15.7757C0.436764 15.5473 0.29833 15.0376 0.526664 14.638L2.30987 11.516C1.6248 10.9197 1.05639 10.3052 0.60186 9.74253C0.312656 9.38451 0.368838 8.85986 0.72686 8.57066C1.08486 8.28165 1.60958 8.33677 1.89873 8.69468C3.34832 10.4892 5.94315 12.7601 10.0003 12.7601C14.0573 12.76 16.6523 10.4892 18.1019 8.69468Z"
                fill="#1E2226"
            />
        </svg>
    );
};

export default IconHidePassword;
